import React from 'react';
import { TFunction } from 'react-i18next';

import { Name } from '@cobalt/react-icon';

export enum CaseStatusEnum {
  New = '001',
  Open = '002',
  Pending = '003',
  OnHold = '004',
  Resolved = '005',
  Closed = '006',
}

export type BgcType = Record<'defaultBgc' | 'hoverBgc' | 'selectedBgc', React.CSSProperties['color']>;

type CaseStatusType = {
  value: CaseStatusEnum;
  text: string;
  icon: Name;
  color: React.CSSProperties['color'];
} & BgcType;
type CaseStatusMap = Record<CaseStatusEnum, CaseStatusType>;

export function genCaseStatusMap(t: TFunction): CaseStatusMap {
  const caseStatusTextMap = {
    [CaseStatusEnum.New]: t('component.case_status.new', { defaultValue: 'New' }),
    [CaseStatusEnum.Open]: t('component.case_status.open', { defaultValue: 'Open' }),
    [CaseStatusEnum.Pending]: t('component.case_status.pending', { defaultValue: 'Pending' }),
    [CaseStatusEnum.OnHold]: t('component.case_status.on_hold', { defaultValue: 'OnHold' }),
    [CaseStatusEnum.Resolved]: t('component.case_status.resolved', { defaultValue: 'Resolved' }),
    [CaseStatusEnum.Closed]: t('component.case_status.closed', { defaultValue: 'Closed' }),
  };

  return {
    [CaseStatusEnum.New]: {
      value: CaseStatusEnum.New,
      text: caseStatusTextMap[CaseStatusEnum.New],
      icon: 'star',
      color: 'var(--blue-700)',
      defaultBgc: 'var(--info-700)',
      hoverBgc: 'var(--info-600)',
      selectedBgc: 'var(--info-800)',
    },
    [CaseStatusEnum.Open]: {
      value: CaseStatusEnum.Open,
      text: caseStatusTextMap[CaseStatusEnum.Open],
      icon: 'radio_button_unchecked',
      color: 'var(--blue-700)',
      defaultBgc: 'var(--info-700)',
      hoverBgc: 'var(--info-600)',
      selectedBgc: 'var(--info-800)',
    },
    [CaseStatusEnum.Pending]: {
      value: CaseStatusEnum.Pending,
      text: caseStatusTextMap[CaseStatusEnum.Pending],
      icon: 'refresh',
      color: 'var(--yellow-700)',
      defaultBgc: 'var(--warning-700)',
      hoverBgc: 'var(--warning-600)',
      selectedBgc: 'var(--warning-800)',
    },
    [CaseStatusEnum.OnHold]: {
      value: CaseStatusEnum.OnHold,
      text: caseStatusTextMap[CaseStatusEnum.OnHold],
      icon: 'pause',
      color: 'var(--yellow-700)',
      defaultBgc: 'var(--warning-700)',
      hoverBgc: 'var(--warning-600)',
      selectedBgc: 'var(--warning-800)',
    },
    [CaseStatusEnum.Resolved]: {
      value: CaseStatusEnum.Resolved,
      text: caseStatusTextMap[CaseStatusEnum.Resolved],
      icon: 'done',
      color: 'var(--green-700)',
      defaultBgc: 'var(--success-700)',
      hoverBgc: 'var(--success-600)',
      selectedBgc: 'var(--success-800)',
    },
    [CaseStatusEnum.Closed]: {
      value: CaseStatusEnum.Closed,
      text: caseStatusTextMap[CaseStatusEnum.Closed],
      icon: 'block',
      color: 'var(--basic-600)',
      defaultBgc: 'var(--basic-600)',
      hoverBgc: 'var(--basic-500)',
      selectedBgc: 'var(--basic-700)',
    },
  };
}
